import React, { Component } from "react";

// import UI components
import { Row, Col, Button, FormGroup } from "reactstrap";
import { Formik, Form, Field } from "formik";
import CustomisedModal from "components/Application/CustomisedModal";
import Select from "react-select";

// import constants
import { SUBMIT, UPDATE, SUCCESS, DANGER } from "constants/commonConstants";

import {
  getProductCategoryListRequest,
  getCategoryListForProductCategoryRequest,
  updateProductCategoryStatusByProductCategoryIdRequest,
  addProductCategoryRequest,
  updateProductCategoryByProductCategoryIdRequest,
} from "store/actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import { toastrMessage } from "helpers/messageHelper";
import { makeProductCategorySelectField } from "store/Masters/ProductCategory/selector";
import { selectSortedCategoriesForProductCategory } from "store/Masters/Category/selector";
import { createStructuredSelector } from "reselect";
import SimpleReactValidator from "simple-react-validator";

class ProductCategoryForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      operationType: SUBMIT,
      productCategoryData: productCategoryDataInitialState(),
    };
    this.validator = new SimpleReactValidator();
  }

  componentDidMount() {
    this.props.getCategoryListForProductCategoryRequest();
  }

  resetForm = (closeModal) => {
    this.setState({
      productCategoryData: productCategoryDataInitialState(),
      operationType: SUBMIT,
    });
    this.validator.hideMessages();

    if (closeModal) {
      this.props.closeModal();
    }
  };

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (
      nextprops.productCategoryApiResponse &&
      this.props.productCategoryApiResponse !==
        nextprops.productCategoryApiResponse
    ) {
      if (nextprops.productCategoryApiResponse.isSuccessResponse) {
        this.props.getProductCategoryListRequest();
        toastrMessage(
          nextprops.productCategoryApiResponse.responseMessage,
          SUCCESS
        );
        this.resetForm(true);
      } else if (!nextprops.productCategoryApiResponse.isSuccessResponse) {
        toastrMessage(
          nextprops.productCategoryApiResponse.responseMessage,
          DANGER
        );
      }
    }

    if (
      nextprops.productCategoryRecord &&
      this.props.productCategoryRecord !== nextprops.productCategoryRecord
    ) {
      if (nextprops.productCategoryRecord.productCategoryId) {
        this.setState({
          productCategoryData: nextprops.productCategoryRecord,
          operationType: UPDATE,
        });
      } else {
        this.resetForm(false);
      }
    }
  }

  formSubmit = (values) => {
    if (this.validator.allValid()) {
      this.setState({ productCategoryData: values });
      if (this.state.operationType === UPDATE) {
        const data = values;
        this.props.updateProductCategoryByProductCategoryIdRequest(
          values.productCategoryId,
          data
        );
      } else {
        const data = values;
        this.props.addProductCategoryRequest(data);
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    return (
      <React.Fragment>
        <CustomisedModal
          modalClass="modal-lg"
          isModalOpen={this.props.formDialog}
          modalTitle="ProductCategory"
          onModalDismiss={() => this.resetForm(true)}
        >
          <Formik
            initialValues={this.state.productCategoryData}
            enableReinitialize={true}
            onSubmit={this.formSubmit}
          >
            {({ values, setFieldValue }) => (
              <Form>
                <Row>
                  <Col lg="12">
                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Select Category</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          component={Select}
                          name="categoryId"
                          options={this.props.sortedCategoryList}
                          onChange={(opt, e) => {
                            setFieldValue("categoryId", opt.value);
                          }}
                          value={this.props.sortedCategoryList.filter(
                            (option) => option.value === values.categoryId
                          )}
                        ></Field>
                        {this.validator.message(
                          "categoryId",
                          values.categoryId,
                          "required"
                        )}
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Product Category Name</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          name="productCategoryName"
                          type="text"
                          className="form-control"
                          autoFocus
                        ></Field>
                        {this.validator.message(
                          "productCategoryName",
                          values.productCategoryName,
                          "required"
                        )}
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Product Category Seq</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          name="productCategorySeq"
                          type="number"
                          className="form-control"
                        ></Field>
                        {this.validator.message(
                          "Product Category Sequence",
                          values.productCategorySeq,
                          "required|numeric|min:1,num"
                        )}
                      </Col>
                    </Row>
                  </Col>
                  <Col lg="12">
                    <FormGroup className="mb-0 text-right">
                      <div>
                        <Button type="submit" color="primary" className="mr-1">
                          {this.state.operationType}
                        </Button>

                        <Button
                          type="reset"
                          color="secondary"
                          onClick={() => this.resetForm(false)}
                        >
                          Reset
                        </Button>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </CustomisedModal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  productCategoryApiResponse: makeProductCategorySelectField(
    "productCategoryApiResponse"
  ),
  sortedCategoryList: selectSortedCategoriesForProductCategory(),
});

const withConnect = connect(mapStatetoProps, {
  getProductCategoryListRequest,
  updateProductCategoryStatusByProductCategoryIdRequest,
  addProductCategoryRequest,
  updateProductCategoryByProductCategoryIdRequest,
  getCategoryListForProductCategoryRequest,
});

export default compose(withConnect, withRouter)(ProductCategoryForm);
//export default withRouter(withConnect)(Index);

function productCategoryDataInitialState() {
  return {
    productCategoryName: "",
    categoryId: "",
    productCategorySeq: "",
  };
}
